import css from 'styled-jsx/css';

/*language=SCSS*/
const staticStyles = css`
  @import 'src/_mixins/vars';
  @import 'src/_mixins/screen-size';

  .HALNotificationIcon {
    opacity: 1;
  }
`;

export default staticStyles;
